import {ref} from 'vue';
import {useLoginStatus} from "./useLoginStatus";
import {useOnline} from "@vueuse/core";
import {watchEffect} from "vue-demi";

const { loginStatus } = useLoginStatus();
const online = useOnline();
const canUpload = ref(online.value && loginStatus.value.account !== null);

export function useCanUpload()
{
    watchEffect(() => {
        canUpload.value = loginStatus.value.account && online.value;
    });
    return canUpload;
}
